import React from "react";
import Icon from "../../Elements/Icon/Icon.tsx";
import BrandedCoverUploader from "../../Reusable/BrandedCoverUploader/BrandedCoverUploader.js";
import { useModal } from "../../../contexts/modalContext/modalContext.js";
import Tooltip from "../../Elements/Tooltip/Tooltip.js";
import ForBusinessOnlyModal from "../ForBusinessOnlyModal/ForBusinessOnlyModal.js";

const CoverImageAction = ({
  itemId,
  iconName,
  isDisabled,
  tooltipDisabled,
}) => {
  const { setModal } = useModal();

  const handleAction = () => {
    !isDisabled
      ? setModal({
          modal: BrandedCoverUploader,
          props: {
            setPerMail: true,
            selectedFileId: itemId,
          },
        })
      : setModal({
          modal: ForBusinessOnlyModal,
        });
  };

  return !tooltipDisabled ? (
    <Tooltip
      id={"updateCoverActionIcon"}
      tooltipTextKey={
        isDisabled
          ? "update-cover-icon-tooltip-text"
          : "available-for-business-only-title"
      }
      top
    >
      <Icon name={iconName || "image"} onClick={handleAction} gray clickable />
    </Tooltip>
  ) : (
    <Icon name={iconName || "image"} onClick={handleAction} gray clickable />
  );
};

export default CoverImageAction;
